//#region DevExtreme Imports

import 'devextreme/ui/tabs'

//#endregion

import { IMRTabsController } from "./tabs.controller"

//#region Asset Imports

import './tabs.scss'
import * as TEMPLATE from './tabs.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrTabs'

export class IMRTabsComponent implements ng.IComponentOptions {

    controller = [IMRTabsController]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE

    transclude = true
}
